import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ToasterActionType } from "../ToastProvider.types";
import { useReducer } from "react";

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ToasterActionType.SHOW_TOAST:
      if (state.length) {
        state[0].props = _objectSpread(_objectSpread({}, state[0].props), {}, {
          open: false
        });
      }

      return state.length < 2 ? state.concat({
        message: action.payload.message,
        props: _objectSpread(_objectSpread({}, action.payload.props), {}, {
          key: new Date().getMilliseconds()
        })
      }) : state;

    case ToasterActionType.HIDE_TOAST:
      return state.map(function (t, i) {
        return i === 0 ? {
          message: t.message,
          props: _objectSpread(_objectSpread({}, t.props), {}, {
            open: false
          })
        } : t;
      });

    case ToasterActionType.REMOVE_TOAST:
      return state.slice(1);
  }
};

export function useToasterReducer() {
  return useReducer(reducer, []);
}